/* eslint-disable no-unused-expressions */
/* global attachEvent */
// *******************************************************************************
// File upload
// *******************************************************************************
// Ref - https://jsfiddle.net/alexjamesbrown/2nzL9f7g/

const filesToUpload = [];
const fileUploadInput = document.querySelectorAll('.mod-file-upload__input');

const fileUploader = (evt, files) => {
  const parentElem = evt.target.closest('.mod-file-upload');
  const selectedList = parentElem.querySelector('.mod-file-upload__list-text-wrapper');
  const selectedListParent = parentElem.querySelector('.mod-file-upload__list');
  const removeTxt = selectedListParent.getAttribute('data-remove-text');
  const editTxt = selectedListParent.getAttribute('data-edit-text');
  let editBut = '';
  if (editTxt) {
    editBut = `<button class='mod-file-upload__list-edit'> ${editTxt} </button>`;
  }
  let fileName = '';
  for (let i = 0; i < files.length; i += 1) {
    fileName += `<li><span class='mod-file-upload__list-text'>${
      files.item(i).name
    }</span>${editBut}<button class='mod-file-upload__list-remove'> ${removeTxt} </button></li>`;
    filesToUpload.push(files[i]);
  }
  selectedListParent.classList.remove('hide');
  selectedList.innerHTML = `<ul>${fileName}</ul>`;
};

if (fileUploadInput) {
  attachEvent('.mod-file-upload__input', 'change', (el) => {
    fileUploader(el, el.target.files);
  });
}

// *******************************************************************************
// Remove uploaded files
// *******************************************************************************

attachEvent('.mod-file-upload__list-remove', 'click', (el) => {
  const removeParentElem = el.target.closest('li');
  removeParentElem.querySelector('.mod-file-upload__list-text').innerHTML;
  removeParentElem.closest('.mod-file-upload').querySelector('input').value = null;
  removeParentElem.remove();
});

// *******************************************************************************
// File drop
// *******************************************************************************

const holder = document.querySelector('.mod-file-upload__inner');

if (holder) {
  holder.ondragover = function () {
    return false;
  };
  holder.ondragend = function () {
    return false;
  };
  holder.ondrop = function (e) {
    document.getElementById('file').files = e.dataTransfer.files;
    fileUploader(e, e.dataTransfer.files);
    e.preventDefault();
  };
}
